// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const DELETION_OF_PHOTOBLOG_COMMENT = "Ma\u017eu koment\u00e1\u0159";
export const DELETION_OF_PHOTOBLOG_POST = "Ma\u017eu p\u0159\u00edsp\u011bvek";
